import React from 'react';

export const FacebookIcon = ({ id, props, isPreview, t }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-labelledby={'svg' + id}
    {...props}
  >
    <title id={'svg' + id}>
      {isPreview ? t('social.icons.disablePreviewMode') : 'Facebook'}
    </title>
    <g>
      <path
        d="M20.0498 12.0498C20.0498 7.6028 16.444 4 12 4C7.55299 4 3.9502 7.6028 3.9502 12.0498C3.9502 16.0667 6.89291 19.3973 10.7422 20.0005V14.3772H8.69808V12.0503H10.7422V10.2758C10.7422 8.25885 11.9422 7.14496 13.7815 7.14496C14.6625 7.14496 15.5847 7.30193 15.5847 7.30193V9.28269H14.5679C13.5697 9.28269 13.2578 9.90404 13.2578 10.5405V12.0498H15.4901L15.1314 14.3767H13.2578V20C17.1041 19.3968 20.0498 16.0662 20.0498 12.0493V12.0498Z"
        fill="black"
      />
    </g>
  </svg>
);
